import { gql } from '@apollo/client';

// Fragment para información básica de categoría
export const BUDGET_CATEGORY_BASIC = gql`
  fragment BudgetCategoryBasic on BudgetCategory {
    id
    code
    name
    color
    budgetItemsCount
    createdAt
    updatedAt
  }
`;

// Fragment para categoría con partidas
export const BUDGET_CATEGORY_WITH_ITEMS = gql`
  fragment BudgetCategoryWithItems on BudgetCategory {
    ...BudgetCategoryBasic
    budgetItems {
      id
      code
      description
      unit
      unitPrice
      isActive
      actionBudgetItemsCount
      usageCount
    }
  }
  ${BUDGET_CATEGORY_BASIC}
`;

// Obtener todas las categorías
export const GET_BUDGET_CATEGORIES = gql`
  query GetBudgetCategories {
    budgetCategories {
      ...BudgetCategoryBasic
    }
  }
  ${BUDGET_CATEGORY_BASIC}
`;

// Obtener una categoría por ID
export const GET_BUDGET_CATEGORY = gql`
  query GetBudgetCategory($id: ID!) {
    budgetCategory(id: $id) {
      ...BudgetCategoryWithItems
    }
  }
  ${BUDGET_CATEGORY_WITH_ITEMS}
`;

// Obtener una categoría por código
export const GET_BUDGET_CATEGORY_BY_CODE = gql`
  query GetBudgetCategoryByCode($code: String!) {
    budgetCategoryByCode(code: $code) {
      ...BudgetCategoryWithItems
    }
  }
  ${BUDGET_CATEGORY_WITH_ITEMS}
`;

// Buscar categorías
export const SEARCH_BUDGET_CATEGORIES = gql`
  query SearchBudgetCategories($searchTerm: String!) {
    searchBudgetCategories(searchTerm: $searchTerm) {
      ...BudgetCategoryBasic
    }
  }
  ${BUDGET_CATEGORY_BASIC}
`;

// Obtener estadísticas de categorías (solo COEX/ADMIN)
export const GET_BUDGET_CATEGORIES_STATS = gql`
  query GetBudgetCategoriesStats {
    budgetCategoriesStats {
      totalCategories
      categoriesWithItems
      categoriesWithoutItems
      itemsByCategory {
        id
        code
        name
        color
        budgetItemsCount
      }
    }
  }
`;
